<template>
  <v-card class="mx-auto">
    <v-img height="300" src="https://cdn.vuetifyjs.com/images/cards/server-room.jpg">
      <v-row align="end" class="fill-height">
        <v-list-item>
          <v-col align-self="start" class="pa-0" cols="12">
            <v-layout justify-center="">
              <v-list-item-avatar class="profile" color="grey" size="200">
                <v-img :src="userPhotoURL" />
              </v-list-item-avatar>
            </v-layout>
          </v-col>
        </v-list-item>
      </v-row>
    </v-img>
    <v-col class="py-0">
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="title"> {{ userName }} </v-list-item-title>
          <v-list-item-subtitle v-if="isLoginUser"> {{ userEmail }} </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-col>
    <v-card-text> {{ userProfile }} </v-card-text>
    <slot name="friendBtn"></slot>
    <v-row>
      <v-col cols="1.5" class="px-0">
        <h4>
          <v-icon class="mr-2"> mdi-star-circle </v-icon> 達成力
        </h4>
        <span class="text-left"> {{ userAchievementPower }} </span>
      </v-col>
      <v-col cols="1.5" class="px-0">
        <h4>
          <v-icon class="mr-2"> mdi-run </v-icon> ジョブ
        </h4>
        <v-btn class="x-small post-link align-center py-1 px-2" color="primary" min-height="20" text @click="toJobPage">
          <span class="text-left"> {{ totalJobs }} </span>
        </v-btn>
      </v-col>
      <v-col cols="1.5" class="px-0">
        <h4>
          <v-icon class="mr-2"> mdi-account-heart </v-icon> 友達
        </h4>
        <v-btn lass="x-small post-link align-center py-1 px-2" color="primary" min-height="20" text @click="toFriendPage">
          <span class="text-left"> {{ totalfriends }} </span>
        </v-btn>
      </v-col>
      <v-col cols="1.5" class="px-0">
        <h4>
          <v-icon class="mr-2"> mdi-account-group </v-icon> グループ
        </h4>
        <v-btn class="x-small post-link align-center py-1 px-2" color="primary" min-height="20" text :to="{ name: 'OtherUserGroupIndex', params: { user_id: userId }}">
          <span class="text-left"> {{ totalGroups }} </span>
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="9" />
      <v-col cols="3">
        <v-card-actions>
          <slot name="editUserBtn" />
        </v-card-actions>
      </v-col>
    </v-row>
    <edit-user-detail-component/>
  </v-card>
</template>

<script>
import EditUserDetailComponent from "./EditUserDetail";

import { mapGetters } from "vuex";

export default {
  components: { EditUserDetailComponent },

  computed: {
    ...mapGetters([
      "myGroups",
      "loginUserEmail",
      "loginUserId",
      "loginUserInfo",
      "loginUserName",
      "loginUserPhotoURL",
      "friend/loginUserFriends",
      "friend/otherUserFriends",
      "job/myJobs",
      "job/otherUserJobs",
      "user/otherUser"
    ]),
    // ユーザーの友達ユーザー数
    totalfriends() {
      let totalfriends = 0;
      const friends = this.isLoginUser ? this["friend/loginUserFriends"] : this["friend/otherUserFriends"];
      friends.forEach((friend) => { if (friend.friendStatus === 3) totalfriends++; });
      return totalfriends;
    },
    // ユーザーの所属グループ数
    totalGroups() { return this.isLoginUser ? this.myGroups.length : this["user/otherUser"].userGroups ? this["user/otherUser"].userGroups.length : 0; },
    // ユーザーの所持ジョブ数
    totalJobs() {
      let totalJobs = 0;
      const jobs = this.isLoginUser ? this["job/myJobs"] : this["job/otherUserJobs"];
      jobs.forEach(job => {
        if (this.isLoginUser || !job.jobPublishingSetting) {
          totalJobs++;
        } else if (this.friendStatus === 3) {
          if (job.jobPublishingSetting !== 3) totalJobs++;
        } else {
          if (job.jobPublishingSetting === 1) totalJobs++;
        }
      })
      return totalJobs;
    },
    // ユーザー達成力
    userAchievementPower() { return this.isLoginUser ? this.loginUserInfo.userAchievementPower : this["user/otherUser"].userAchievementPower; },
    // ユーザーメールアドレス
    userEmail()  { return this.isLoginUser ? this.loginUserEmail : this["user/otherUser"].userEmail },
    // ユーザーID
    userId() { return this.isLoginUser ? this.loginUserId : this["user/otherUser"].userId; },
    // ユーザー名
    userName() { return this.isLoginUser ? this.loginUserName : this["user/otherUser"].userName; },
    // ユーザー画像
    userPhotoURL() { return this.isLoginUser ? this.loginUserPhotoURL : this["user/otherUser"].userPhotoURL; },
    // ユーザープロフィール
    userProfile() {
      return this.isLoginUser ? this.loginUserInfo.userProfile : this["user/otherUser"].userProfile;
    }
  },

  methods: {
    toJobPage() {
      if (this.isLoginUser) {
        this.$router.push("/job_index");
      } else {
        this.$router.push({ name: "OtherUserJobIndex", param: { "user_id": this.userId } });
      }
    },
    toFriendPage() {
      if (this.isLoginUser) {
        this.$router.push("/friend");
      } else {
        this.$router.push({ name: "Friend", params: { isLoginUser: this.isLoginUser, "user_id": this.userId } });
      }
    }
  },

  props: {
    isLoginUser: Boolean,
    friendStatus: Number
  }
};
</script>
